import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';

import Connectors from '../Connectors';
import { getConnectorId } from '../../Sources/source-operations';
import Sources from '../../Sources/Sources';

Meteor.publish('connectors', function connectors() {
  return Connectors.find({ owner: this.userId });
});

// Note: connectors.view is also used when editing an existing document.
Meteor.publish('connectors.view', function connectorsView(connectorId) {
  check(connectorId, String);
  return Connectors.find({ _id: connectorId, owner: this.userId });
});

Meteor.publish('connectors.source', function connectorsSource(sourceId) {
  check(sourceId, String);
  const source = Sources.findOne(sourceId);
  const connectorId = getConnectorId(source);
  return Connectors.find({ _id: connectorId, owner: this.userId });
});
